import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import useTranslation from "next-translate/useTranslation";

import { UseCaseHeaderSectionItem } from "../UseCaseHeaderSectionItem";

interface IUseCaseHeaderSection {
  title: string;
}

type IProps = IUseCaseHeaderSection & JSX.IntrinsicElements["div"];

export const UseCaseHeaderSection: React.FC<IProps> = ({ title }) => {
  const { t } = useTranslation();
  const { css } = useFela();
  const { bp, colors } = useTheme();
  return (
    <div
      className={css({
        width: "100%",
        background: colors.WHITE,
        boxShadow: "0px 10px 35px rgba(0, 0, 0, 0.03)",
        borderRadius: 12,
        padding: "28px 30px",
        [bp.FROM_TABLET]: {
          padding: "56px 60px",
        },
        [bp.FROM_DESKTOP]: {
          position: "absolute",
          top: -120,
        },
      })}
    >
      <Heading
        as="h2"
        customStyle={{
          letterSpacing: "-0.01rem",
          textAlign: "center",
        }}
      >
        {title}
      </Heading>
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          paddingTop: 10,
          [bp.FROM_TABLET]: {
            flexDirection: "row",
          },
        })}
      >
        <UseCaseHeaderSectionItem
          title={t(
            "page/solutionsForEnterprise:section/useCases.useCasesTitleList.fileMigration.title",
          )}
          text={t(
            "page/solutionsForEnterprise:section/useCases.useCasesTitleList.fileMigration.text",
          )}
          icon={t(
            "page/solutionsForEnterprise:section/useCases.useCasesTitleList.fileMigration.icon",
          )}
        />
        <UseCaseHeaderSectionItem
          title={t(
            "page/solutionsForEnterprise:section/useCases.useCasesTitleList.teamCollaboration.title",
          )}
          text={t(
            "page/solutionsForEnterprise:section/useCases.useCasesTitleList.teamCollaboration.text",
          )}
          icon={t(
            "page/solutionsForEnterprise:section/useCases.useCasesTitleList.teamCollaboration.icon",
          )}
        />
        <UseCaseHeaderSectionItem
          title={t(
            "page/solutionsForEnterprise:section/useCases.useCasesTitleList.dataSecurity.title",
          )}
          text={t(
            "page/solutionsForEnterprise:section/useCases.useCasesTitleList.dataSecurity.text",
          )}
          icon={t(
            "page/solutionsForEnterprise:section/useCases.useCasesTitleList.dataSecurity.icon",
          )}
        />
      </div>
    </div>
  );
};
